import React, { useEffect, useState, useRef } from 'react';
import MobileMyCoachingFirstPage from './mobilemycoachingfirstpage';
import InnerHeader from '../etc/innerheader';
import CoachingHeader from './etc/coachingheader';
import { getFetch } from '../../fetch/fetch';
import { CircularProgress } from '@mui/joy';
import { useLocation } from 'react-router-dom';
import MobileSelectCoach from './mobileselectcoach';
import MobileCoachSelectFinish from './mobilecoachselectfinish';
import MobileSubmitFiles from './mobilesubmitfiles';

const MobileMyCoaching: React.FC<any> = (props) => {

    const topDivRef = useRef<any>(null);
    const [statusDivHeight, setStatusDivHeight] = useState(0);
    const [currentStatus, setCurrentStatus] = useState(-1);
    const [subStatus, setSubStatus] = useState(1);
    const location : any = useLocation();




    useEffect(() => {

        if (!topDivRef || !topDivRef.current) {
            return;
        }

        const calculateStatusDivHeight = () => {

            setTimeout(() => {

                if (!topDivRef || !topDivRef.current) {
                    return;
                }

                const totalHeight = window.innerHeight;
                const topDivHeight = topDivRef.current.offsetHeight;

                const statusDivHeight = totalHeight - topDivHeight;

                setStatusDivHeight(statusDivHeight);

            }, 20);

        }

        calculateStatusDivHeight();

        window.addEventListener("resize", () => calculateStatusDivHeight());

        return () => window.removeEventListener("resize", () => calculateStatusDivHeight());

    }, [topDivRef]);

    useEffect(() => {

        currentCoachingStatusCheck();

    }, [location]);


    const currentCoachingStatusCheck = async () => {

        try{

            if(location && location.state && location.state.nextCurrentStatus) {
                const nextCurrentStatus = location.state.nextCurrentStatus;
                setCurrentStatus(nextCurrentStatus);
                console.log("currentStatus from location state: ", nextCurrentStatus);

                if(location.state.nextSubStatus) {
                    const nextSubStatus = location.state.nextSubStatus;
                    setSubStatus(nextSubStatus);
                    console.log("subStatus from location state: ", nextSubStatus);
                }

                return;
            }

            const result : any = await getFetch("/dashboard/mycoach/currentcoachingstatus");

            const currentStatus = result.currentStatus;
            const subStatus = result.subStatus;

            setCurrentStatus(currentStatus);
            setSubStatus(subStatus);

            console.log("currentStatus: ", currentStatus);

        }catch(e){
            console.log("error");
        }

    }

    const handleCurrentStatusChange = (status: number) => {
        setCurrentStatus(status);
        console.log("Current status changed to: ", status);
    }

    const handleSubStatusChange = (status: number) => {
        setSubStatus(status);
        console.log("Sub status changed to: ", status);
    }


    return (
        <div>
            <div ref={topDivRef}>
                <CoachingHeader 
                currentStatus={currentStatus}
                home={((currentStatus === 2 && subStatus === 2) || (currentStatus === 3)) ? true : false}
                />
            </div>
            {
                (currentStatus === -1 && statusDivHeight) ?
                <div style={{
                    width: "100%",
                    height: `${statusDivHeight}px`,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}>
                    <CircularProgress
                        style={{
                            width: "3rem",
                            height: "3rem"
                        }}
                        color="primary"
                    />
                </div>
                :
                ""
            }
            {
                currentStatus === 1 ? 
                <MobileMyCoachingFirstPage 
                statusDivHeight={statusDivHeight}
                user={props.user}
                />
                :
                ""
            }
            {
                (currentStatus === 2 && subStatus === 1) ?
                <MobileSelectCoach
                statusDivHeight={statusDivHeight}
                user={props.user}
                handleCurrentStatusChange={handleCurrentStatusChange}
                handleSubStatusChange={handleSubStatusChange}
                />
                :
                ""
            }
            {
                (currentStatus === 2 && subStatus === 2) ?
                <MobileCoachSelectFinish
                statusDivHeight={statusDivHeight}
                user={props.user}
                handleCurrentStatusChange={handleCurrentStatusChange}
                handleSubStatusChange={handleSubStatusChange}
                />
                :
                ""
            }
            {
                (currentStatus === 3 && subStatus === 1) ?
                <MobileSubmitFiles
                statusDivHeight={statusDivHeight}
                user={props.user}
                />
                :
                ""
            }


        </div>
    )
}

export default MobileMyCoaching;